document.addEventListener("DOMContentLoaded", () => {
  // --- Global State ---
  const mouse = { x: 0.5, y: 0.5, px: window.innerWidth / 2, py: window.innerHeight / 2 };
  const smoothMouse = { x: 0.5, y: 0.5, px: window.innerWidth / 2, py: window.innerHeight / 2 };
  const LERP_FACTOR = 0.22; // Increased from 0.1 for snappier response

  window.addEventListener("mousemove", (e) => {
    mouse.px = e.clientX;
    mouse.py = e.clientY;
    mouse.x = e.clientX / window.innerWidth;
    mouse.y = e.clientY / window.innerHeight;
  });

  // --- Global Parallax & Canvas ---
  const globalGrid = document.querySelector(".js-global-grid");
  const globalSpotlight = document.querySelector(".js-global-spotlight");
  const canvas = document.getElementById("global-canvas");
  const cursor = document.querySelector(".js-cursor");

  if (canvas) {
    const ctx = canvas.getContext("2d");
    let w, h;
    const resize = () => {
      const dpr = Math.min(2, window.devicePixelRatio || 1);
      w = window.innerWidth;
      h = window.innerHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    window.addEventListener("resize", resize);
    resize();

    const readAccent = () => getComputedStyle(document.documentElement).getPropertyValue("--accent").trim() || "oklch(0.62 0.24 295)";
    const withA = (col, a) => {
      const m = col.match(/oklch\(([^)]+)\)/);
      return m ? `oklch(${m[1]} / ${a})` : col;
    };

    const canvasTick = (t) => {
      const elapsed = t / 1000;
      const accent = readAccent();
      ctx.clearRect(0, 0, w, h);
      const step = 64; 
      for (let i = 0; i <= Math.ceil(w / step); i++) {
        for (let j = 0; j <= Math.ceil(h / step); j++) {
          const x = i * step, y = j * step;
          const dx = smoothMouse.px - x, dy = smoothMouse.py - y;
          const d = Math.hypot(dx, dy), infl = Math.exp(-d / 260);
          const ambient = Math.sin(x * 0.01 + y * 0.012 + elapsed * 0.6) * 0.6;
          const ang = Math.atan2(dy, dx) * infl + ambient * (1 - infl);
          const len = 4 + infl * 14;
          ctx.strokeStyle = withA(accent, 0.12 + infl * 0.55);
          ctx.lineWidth = 1 + infl * 0.8;
          ctx.beginPath();
          ctx.moveTo(x - Math.cos(ang) * len / 2, y - Math.sin(ang) * len / 2);
          ctx.lineTo(x + Math.cos(ang) * len / 2, y + Math.sin(ang) * len / 2);
          ctx.stroke();
        }
      }
      const g = ctx.createRadialGradient(smoothMouse.px, smoothMouse.py, 0, smoothMouse.px, smoothMouse.py, 140);
      g.addColorStop(0, withA(accent, 0.22)); g.addColorStop(1, withA(accent, 0));
      ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
      
      // Removed the redundant canvas dot since we have a DOM cursor now
      // ctx.beginPath(); ctx.fillStyle = withA(accent, 0.95);
      // ctx.arc(smoothMouse.px, smoothMouse.py, 3, 0, Math.PI * 2); ctx.fill();
      
      requestAnimationFrame(canvasTick);
    };
    requestAnimationFrame(canvasTick);
  }

  // --- Cursor Interaction ---
  if (cursor) {
    const interactive = document.querySelectorAll("a, button, .btn, .receipt, .service, .js-nav-toggle");
    interactive.forEach(el => {
      el.addEventListener("mouseenter", () => cursor.classList.add("is-hovering"));
      el.addEventListener("mouseleave", () => cursor.classList.remove("is-hovering"));
    });
  }

  // --- Counter Animation ---
  const counters = document.querySelectorAll(".js-count");
  const countObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const targetValue = el.getAttribute("data-target");
        const target = parseFloat(targetValue.replace(/,/g, ""));
        const duration = 2000;
        const startTime = performance.now();
        
        const animate = (currentTime) => {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const easeProgress = 1 - Math.pow(1 - progress, 3);
          const currentCount = easeProgress * target;
          
          if (targetValue.includes(".")) {
            el.innerText = currentCount.toFixed(1);
          } else {
            el.innerText = Math.floor(currentCount).toLocaleString();
          }

          if (progress < 1) {
            requestAnimationFrame(animate);
          } else {
            el.innerText = targetValue;
          }
        };
        
        requestAnimationFrame(animate);
        countObserver.unobserve(el);
      }
    });
  }, { threshold: 0.1 });

  counters.forEach(counter => countObserver.observe(counter));

  // --- Reveal Animation ---
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.05 }); // Reduced from 0.15 to support tall sections on short viewports

  document.querySelectorAll(".reveal").forEach(el => revealObserver.observe(el));
  document.querySelectorAll(".hero-reveal").forEach(el => {
    setTimeout(() => {
      el.classList.add("is-visible");
    }, 100);
  });

  // --- Mobile Menu ---
  const navToggle = document.querySelector(".js-nav-toggle");
  const navMenu = document.querySelector(".nav-menu");
  const nav = document.querySelector(".nav");

  if (navToggle && navMenu) {
    navToggle.addEventListener("click", () => {
      navMenu.classList.toggle("is-active");
      nav.classList.toggle("is-menu-open");
      document.body.classList.toggle("locked");
    });

    // Close menu on link click
    const menuLinks = navMenu.querySelectorAll("a");
    menuLinks.forEach(link => {
      link.addEventListener("click", () => {
        navMenu.classList.remove("is-active");
        nav.classList.remove("is-menu-open");
        document.body.classList.remove("locked");
      });
    });
  }

  // --- Showcase Interpolated State ---
  const abRows = document.querySelectorAll(".js-ab-row");
  const rowStates = Array.from(abRows).map(row => ({
    el: row,
    currentSplit: 0,
    targetSplit: 0,
    currentProgress: 0,
    targetProgress: 0
  }));

  const mainTick = () => {
    // 1. Smooth Mouse
    smoothMouse.x += (mouse.x - smoothMouse.x) * LERP_FACTOR;
    smoothMouse.y += (mouse.y - smoothMouse.y) * LERP_FACTOR;
    smoothMouse.px += (mouse.px - smoothMouse.px) * LERP_FACTOR;
    smoothMouse.py += (mouse.py - smoothMouse.py) * LERP_FACTOR;

    // 2. Parallax & Cursor Updates
    const heroTitle = document.querySelector(".js-hero-title");
    if (heroTitle) {
      const isDesktop = window.innerWidth > 1024;
      const tx = (smoothMouse.x - 0.5) * 16;
      const ty = (smoothMouse.y - 0.5) * 10;

      if (isDesktop) {
        const rx = (smoothMouse.y - 0.5) * -15; // Vertical rotation
        const ry = (smoothMouse.x - 0.5) * 20;  // Horizontal rotation
        heroTitle.style.transform = `translate3d(${tx}px, ${ty}px, 0) rotateX(${rx}deg) rotateY(${ry}deg)`;
      } else {
        heroTitle.style.transform = `translate(${tx}px, ${ty}px)`;
      }
    }
    if (globalGrid) {
      globalGrid.style.setProperty("--mx", `${smoothMouse.x * 100}%`);
      globalGrid.style.setProperty("--my", `${smoothMouse.y * 100}%`);
    }
    if (globalSpotlight) {
      globalSpotlight.style.setProperty("--mx", `${smoothMouse.px}px`);
      globalSpotlight.style.setProperty("--my", `${smoothMouse.py}px`);
    }
    if (cursor) {
      cursor.style.transform = `translate3d(${smoothMouse.px}px, ${smoothMouse.py}px, 0) translate(-50%, -50%)`;
    }

    // 3. Showcase Updates
    const vh = window.innerHeight;
    rowStates.forEach(state => {
      const rect = state.el.getBoundingClientRect();
      const start = vh;
      const end = -rect.height;
      
      state.targetProgress = Math.max(0, Math.min(1, (start - rect.top) / (start - end)));
      state.currentProgress += (state.targetProgress - state.currentProgress) * LERP_FACTOR;

      let split = 0;
      const p = state.currentProgress;
      if (p < 0.25) split = 0;
      else if (p < 0.55) split = (p - 0.25) / 0.3;
      else if (p < 0.8) split = 1;
      else split = Math.max(0, 1 - (p - 0.8) / 0.2);

      const inX = mouse.px >= rect.left - 100 && mouse.px <= rect.right + 100;
      const inY = mouse.py >= rect.top - 120 && mouse.py <= rect.bottom + 120;
      if (inX && inY) {
        const relX = (mouse.px - rect.left) / rect.width;
        const centerProx = 1 - Math.abs(relX - 0.5) * 2;
        split = Math.min(1, split + centerProx * 0.3);
      }

      state.targetSplit = split;
      state.currentSplit += (state.targetSplit - state.currentSplit) * LERP_FACTOR;

      const card = state.el.querySelector(".js-ab-card");
      const halfA = state.el.querySelector(".js-ab-a");
      const halfB = state.el.querySelector(".js-ab-b");
      const halfC = state.el.querySelector(".js-ab-c");
      const crease = state.el.querySelector(".js-ab-crease");

      const s = state.currentSplit;
      const yOffset = (0.5 - Math.min(state.currentProgress, 0.5)) * 30;
      const cardOpacity = Math.max(0.45, Math.min(1, state.currentProgress * 3));

      if (card) {
        card.style.transform = `translateY(${yOffset}px)`;
        card.style.opacity = cardOpacity;
      }
      const isMobile = window.innerWidth <= 1024;

      if (halfA) halfA.style.transform = isMobile ? "" : `translateX(${-s * 100}%)`;
      if (halfB) halfB.style.transform = isMobile ? "" : `translateX(${s * 100}%)`;
      if (halfC) {
        halfC.style.opacity = isMobile ? 1 : Math.max(0, s * 1.15 - 0.08);
        halfC.style.transform = isMobile ? "" : `translate(-50%, -50%) scale(${0.85 + s * 0.15})`;
      }
      if (crease) crease.style.opacity = isMobile ? 0 : Math.max(0, 1 - s * 1.3);
    });

    requestAnimationFrame(mainTick);
  };

  requestAnimationFrame(mainTick);

  // --- Popup Logic ---
  const popupTriggers = document.querySelectorAll(".js-open-popup");
  const popups = document.querySelectorAll(".popup-stage");

  const openPopup = (id) => {
    const popup = document.getElementById(id);
    if (popup) {
      popup.classList.add("is-active");
      document.body.classList.add("locked");
      const firstInput = popup.querySelector("input, textarea");
      if (firstInput) setTimeout(() => firstInput.focus(), 600);
    }
  };

  const closePopup = (popup) => {
    popup.classList.remove("is-active");
    // Only unlock if mobile menu isn't also open
    if (!document.querySelector(".nav-menu.is-active")) {
      document.body.classList.remove("locked");
    }
  };

  popupTriggers.forEach(trigger => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      const target = trigger.getAttribute("data-target");
      openPopup(target);
    });
  });

  popups.forEach(popup => {
    const closeBtn = popup.querySelector(".popup-modal__close");
    const backdrop = popup.querySelector(".popup-backdrop");
    const form = popup.querySelector("form");
    const modal = popup.querySelector(".popup-modal");

    if (closeBtn) closeBtn.addEventListener("click", () => closePopup(popup));
    if (backdrop) backdrop.addEventListener("click", () => closePopup(popup));

    // Success state
    if (form) {
      form.addEventListener("submit", (e) => {
        // Only if it's the static form, CF7 has its own events
        if (!form.classList.contains("wpcf7-form")) {
          e.preventDefault();
          const data = Object.fromEntries(new FormData(form).entries());
          console.log("Form submitted:", data);
          modal.classList.add("is-success");
        }
      });
    }

    // CF7 specific success event
    document.addEventListener("wpcf7mailsent", (e) => {
      const formId = e.detail.contactFormId;
      // You could check for specific form ID if needed
      if (popup.contains(e.target)) {
        modal.classList.add("is-success");
      }
    }, false);

    // Interactive elements for custom cursor
    const interactive = popup.querySelectorAll("a, button, input, textarea, .btn");
    interactive.forEach(el => {
      el.addEventListener("mouseenter", () => cursor?.classList.add("is-hovering"));
      el.addEventListener("mouseleave", () => cursor?.classList.remove("is-hovering"));
    });
  });

  // Esc key to close all popups
  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      popups.forEach(popup => {
        if (popup.classList.contains("is-active")) closePopup(popup);
      });
    }
  });

  // --- Smooth Scroll for anchor links ---
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href === '#') return;
      
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        const headerOffset = 70;
        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    });
  });

  // Handle hash on page load
  if (window.location.hash) {
    const target = document.querySelector(window.location.hash);
    if (target) {
      setTimeout(() => {
        const headerOffset = 70;
        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }, 500); // Delay to allow layout/animations to settle
    }
  }
});
